import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { GItem } from '@app/cp/shared/models/GItem';
import { process, aggregateBy, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { EquipBoardData } from '../../shared/models/EquipBoardData';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { v_DispatchPartsOrderedBus } from '../../shared/models/v_DispatchPartsOrderedBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { AppClaims } from '@app/cp/shared/models/AppClaims';
import { CmProAuthService } from '@app/core/services';
import { CommonValues } from '@app/cp/shared/static/CommonValues';

interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@Component({
    selector: 'cp-equipment-board',
    templateUrl: './equipment-board.component.html',
    styleUrls: ['./equipment-board.component.scss']
})
export class EquipmentBoardComponent extends BaseGridComponent<EquipBoardData, null> implements OnInit, OnDestroy {

    public aggregates: any[] = [];
    public aggregateResults;
    public gridView: GridDataResult;
    public pageSize = 15;
    public confirmBtnStyle: string = 'outline';
    public confirmBtnDisabled: boolean = false;
    public confirmBtnLoading: boolean = false;
    customerNameCF: MSCLFilterClass;
    contractAdministratorCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    pmCF: MSCLFilterClass;
    divisionNameCF: MSCLFilterClass;
    subs_dataRefUpdated: Subscription;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService, svc_dispatch: DispatchesService, private authService: CmProAuthService) {

        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.svc_dispatch = svc_dispatch;
        this.skip = 0;

        this.aggregates = [
            { field: 'contractNumber', aggregate: 'count' },
            { field: 'jobNumber', aggregate: 'count' },
            { field: 'jobTotal', aggregate: 'sum' },
            { field: 'totalCostsToDate', aggregate: 'sum' },
            { field: 'profitDollars', aggregate: 'sum' },
            { field: 'origEstProfit', aggregate: 'sum' },
            { field: 'estBudget', aggregate: 'sum' },
            { field: 'caTotal', aggregate: 'sum' },
            { field: 'bidSale', aggregate: 'sum' },
            { field: 'bidHrs', aggregate: 'sum' },
            { field: 'actHrs', aggregate: 'sum' },
            { field: 'bidCost', aggregate: 'sum' },
            { field: 'jobCost', aggregate: 'sum' },
            { field: 'ogBidSale', aggregate: 'sum' },
            { field: 'ogBidCost', aggregate: 'sum' },
            { field: 'ogJobCost', aggregate: 'sum' },
            { field: 'profit', aggregate: 'sum' },
            { field: 'percComplete', aggregate: 'sum' },
            { field: 'origEstProfit', aggregate: 'sum' }
        ];
    }

    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    svc_dispatch: DispatchesService;
    referenceData: DQOIReferenceData;
    contractAdministratorId: any;

    gridDataPrime: any[] = [];
    constractNo: string;
    billingMonthYear: any;
    projectManagerId: any;

    //Filters
    jobPMs: GItem[] = [];
    customers: GItem[] = [];
    jobClasses: GItem[] = [];
    jobStatuses: GItem[] = [];
    contractStatuses: GItem[] = [];
    contractPMs: GItem[] = [];
    coordinators: GItem[] = [];
    divisions: GItem[] = [];

    JobPMIds: GItem[] = [];
    dispatchStatusIds: GItem[] = [];
    customerIds: GItem[] = [];
    jobClassIds: GItem[] = [];
    jobStatusIds: GItem[] = [];
    contractStatusIds: GItem[] = [];
    contractPMIds: GItem[] = [];
    coordinatorIds: GItem[] = [];
    divisionsIds: GItem[] = [];

    filteredData: any[];
    exportFilteredData: any[];

    ColumnHeaders: ColumnSetting[];
    loading: boolean = true;
    private getDataSubscription: Subscription;
    rights: AppClaims = new AppClaims();
    ngOnInit() {
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
        this.loading = true;
        this.pageSize = 45;
        this.getData();
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });

    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.unsubscribeAll();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
        this.authService.unsubscribeToLoginEvents();
    }
    public gridData2: any;// = process(this.gridData, this.state);

    getData() {
        this.totalContractCount = 0;
        let param: ConstructionSearchParam = this.getParam();
        this.svc_data.getEquipBoardInfo(param).subscribe(
            {
                next: (data: BaseMessageInfo) => {
                    if (!data.warning && !data.saveError) {
                        console.log('Equip Board Info: ' + JSON.stringify(data));
                        let arr = [];
                        for (let i = 0; i < data.primaryReturn.length; i++) {
                            let newObj: EquipBoardData = new EquipBoardData(data.primaryReturn[i]);
                            arr.push(newObj);
                        }

                        this.gridData = arr;
                        //this.gridData = _.cloneDeep(data.primaryReturn);//.slice(0, 5);
                        this.applyFilters();
                        this.processGridData();
                        this.PopulateFilters(this.gridData);
                        this.loadEntries();
                        //this.gridData2 = process(this.gridData, this.state);

                        this.loading = false;
                    } else {
                        this.handleNetworkError(data.message);
                    }
                },
                error: err => {
                    this.handleNetworkError(`Network Error retrieving Equipment Board Info. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                }
            }
        );
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        super.dataStateChange(state);
        this.processGridData();
        //this.gridData = process(this.data, this.state);
    }

    totalContractCount: number = 0;
    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.state.filter);
        if (CommonFunctions.hasArrayElementValue(this.exportFilteredData)) {
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
        }
        this.totalContractCount = this.filteredData.map(item => item.contractId).filter((value, index, self) => self.indexOf(value) === index).length;
        this.customerNameCF = new MSCLFilterClass('customerName', 'customerName', this.filteredData);
        this.contractAdministratorCF = new MSCLFilterClass('contractAdministrator', 'contractAdministrator', this.filteredData);
        this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.filteredData);
        this.divisionNameCF = new MSCLFilterClass('divisionName', 'divisionName', this.filteredData);
        this.pmCF = new MSCLFilterClass('pm', 'pm', this.filteredData);
        this.loading = false;
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError(error);
    }

    showError(error) {
        this.globals.notifyError(error,true)
        this.loading = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }
    clearData() {
        this.gridData = [];
        this.filteredData = [];
        this.loading = true;
    }

    refreshData() {
        this.clearData();
        this.getData();
    }

    unsubscribeAll() {
        if (this.getDataSubscription) {
            this.getDataSubscription.unsubscribe();
        }
    }

    getParam(initial: boolean = false): ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();
        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.jobClassIds = this.jobClassIds;
            param.dispatchStatusIds = this.dispatchStatusIds;
        }
        return param;
    }

    applyFilters() {
        this.totalContractCount = 0;
        this.loading = true;
        this.filteredData = [];
        if (this.JobPMIds.length == 0 && this.customerIds.length == 0 && this.jobClassIds.length == 0 && this.jobStatusIds.length == 0
            && this.contractStatusIds.length == 0 && this.contractPMIds.length == 0 && this.coordinatorIds.length == 0 && this.divisionsIds.length == 0) {
            this.filteredData = _.cloneDeep(this.gridData);
        } else {
            let tempFilteredData = _.cloneDeep(this.gridData);
            if (this.JobPMIds.length > 0) {
                tempFilteredData.forEach(row => {
                    let filterIndex = this.JobPMIds.findIndex((element) => { return element === row.jobPMId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.customerIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.customerIds.findIndex((element) => { return element === row.customerId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.jobClassIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobClassIds.findIndex((element) => { return element === row.jobClassId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.jobStatusIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobStatusIds.findIndex((element) => { return element === row.dispatchStatusId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.contractStatusIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.contractStatusIds.findIndex((element) => { return element === row.contractStatusId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.contractPMIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.contractPMIds.findIndex((element) => { return element === row.contractPMId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.coordinatorIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.coordinatorIds.findIndex((element) => { return element === row.coordinatorId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
            if (this.divisionsIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridData);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.divisionsIds.findIndex((element) => { return element === row.contractDivisionId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.jobId === row.jobId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
        }
        this.processGridData();
    }

    clearFilters() {
        this.loading = true;
        this.filteredData = [];
        this.JobPMIds = [];
        this.dispatchStatusIds = [];
        this.customerIds = [];
        this.jobClassIds = [];
        this.jobStatusIds = [];
        this.contractStatusIds = [];
        this.contractPMIds = [];
        this.coordinatorIds = [];
        this.divisionsIds = [];
        this.applyFilters();
    }

    showAdjustPopup: boolean = false;
    currentJobId: any;
    currentJobNumber: any;

    openAdjustmentPopup(jobId, jobNum) {
        this.currentJobId = jobId;
        this.currentJobNumber = jobNum;
        this.showAdjustPopup = true;
    }

    closeAdjustmentPopup() {
        this.currentJobId = null;
        this.currentJobNumber = null;
        this.showAdjustPopup = false;
        this.loading = true;
        this.getData();
    }

    subs_partsOrd: Subscription;
    partsOrderedLoading: boolean = false;
    vendorPoInfo: v_DispatchPartsOrderedBus[];
    getPartsOrdered(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.partsOrderedLoading = true;
            CommonFunctions.unsubscribe(this.subs_partsOrd);
            this.subs_partsOrd = this.svc_dispatch.GetDispatchPartsOrdered(id).subscribe(data => {
                console.log('raw vendor data: ' + JSON.stringify(data));
                let arr: v_DispatchPartsOrderedBus[] = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        arr.push(new v_DispatchPartsOrderedBus(data[i]));
                    }
                }
                this.vendorPoInfo = arr;

                this.partsOrderedLoading = false;
            });
        }
        else {
            this.vendorPoInfo = [];
        }
    }

    detailOpen: boolean = false;
    openVendPoDetails(id) {
        this.detailOpen = true;
        this.getPartsOrdered(id);
    }
    closeVendPODetails() {
        this.detailOpen = false;
        this.vendorPoInfo = [];
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    invoiceDetailOpen: boolean = false;
    openInvoiceDetails(id) {
        this.invoiceDetailOpen = true;
        this.getInvoiceDetails(id);
    }
    closeInvoiceDetails() {
        this.invoiceDetailOpen = false;
        this.invoiceDetailData = [];

    }
    invoiceDetailData: any[] = [];
    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();
    getInvoiceDetails(contractId) {
        this.constSearchParam.contractId = contractId;
        this.svc_data.GetEquipmentDrawsByJobId(this.constSearchParam).subscribe((dynData: BaseMessageInfo) => {
            if (dynData && dynData.primaryReturn && dynData.primaryReturn.length > 0 && !dynData.warning) {
                console.log('Raw Dynamic Draw Data: ' + JSON.stringify(dynData.primaryReturn));
                this.invoiceDetailData = dynData.primaryReturn;
            }
        });
    }

    public PopulateFilters(data: any) {
        data.forEach(item => {
            if (this.jobPMs.findIndex((element) => { return element.value === item.jobPMId }) == -1) {
                if (this.jobPMs.findIndex(a => a.value == item.jobPMId) < 0) {
                    this.jobPMs.push({ description: item.jobPM, value: item.jobPMId, category: null, "reference": null })
                }
            }
            if (this.customers.findIndex((element) => { return element.value === item.customerId }) == -1) {
                if (this.customers.findIndex(a => a.value == item.customerId) < 0) {
                    this.customers.push({ description: item.customerName, value: item.customerId, category: null, "reference": null })
                }
            }
            if (this.jobClasses.findIndex((element) => { return element.value === item.jobClassId }) == -1) {
                if (this.jobClasses.findIndex(a => a.value == item.jobClassId) < 0) {
                    this.jobClasses.push({ description: item.jobClassName, value: item.jobClassId, category: null, "reference": null })
                }
            }
            if (this.jobStatuses.findIndex((element) => { return element.value === item.dispatchStatusId }) == -1) {
                if (this.jobStatuses.findIndex(a => a.value == item.dispatchStatusId) < 0) {
                    this.jobStatuses.push({ description: item.dispatchStatusName, value: item.dispatchStatusId, category: null, "reference": null })
                }
            }
            if (this.contractStatuses.findIndex((element) => { return element.value === item.contractStatusId }) == -1) {
                if (this.contractStatuses.findIndex(a => a.value == item.contractStatusId) < 0) {
                    this.contractStatuses.push({ description: item.contractStatusName, value: item.contractStatusId, category: null, "reference": null })
                }
            }
            if (this.contractPMs.findIndex((element) => { return element.value === item.contractPMId }) == -1) {
                if (this.contractPMs.findIndex(a => a.value == item.contractPMId) < 0) {
                    this.contractPMs.push({ description: item.contractPM, value: item.contractPMId, category: null, "reference": null })
                }
            }
            if (this.coordinators.findIndex((element) => { return element.value === item.coordinatorId }) == -1) {
                if (this.coordinators.findIndex(a => a.value == item.coordinatorId) < 0) {
                    this.coordinators.push({ description: item.coordinatorName, value: item.coordinatorId, category: null, "reference": null })
                }
            }
            if (this.divisions.findIndex((element) => { return element.value === item.contractDivisionId }) == -1) {
                if (this.divisions.findIndex(a => a.value == item.contractDivisionId) < 0) {
                    this.divisions.push({ description: item.divisionName, value: item.contractDivisionId, category: null, "reference": null })
                }
            }
        });
        this.jobPMs.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.customers.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.jobClasses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.jobStatuses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.contractStatuses.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.contractPMs.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.coordinators.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
        this.divisions.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadEntries();
    }

    private loadEntries(): void {
        this.gridView = {
            data: this.filteredData.slice(this.skip, this.skip + this.pageSize),
            total: this.filteredData.length
        };
    }

    public expandDetail() {
        return true;
    }

    public filter: CompositeFilterDescriptor;
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.exportFilteredData as any, {}).data,
        };
        return result;
    }
}
